export function useKioskMode() {
  const isKioskMode = useState("kioskMode", () => false);
  const kioskRfid = useState("kioskRfid", () => "");

  const enableKioskMode = () => {
    isKioskMode.value = true;
  };

  const setKioskRfid = (value: string) => {
    kioskRfid.value = value;
  };

  return { isKioskMode, enableKioskMode, kioskRfid, setKioskRfid };
}
